import getPageName from "./getPageName";

const site = () => {
  /**
   * Плавный скролл
   */
  function setNavigation() {
    $("a[href^='#']:not(.employment-formats__btn):not([rel='modal:open'])").on(
      "click",
      function (e) {
        e.preventDefault();
        $("html,body")
          .stop()
          .animate(
            {
              scrollTop:
                $(`#${this.href.split("#").pop()}`).offset()?.top - 100,
            },
            700
          );
      }
    );
  }

  /**
   * Collapse
   */
  function collapseList(wrapper, btns, collapse, icon) {
    let wrap = document.querySelector(wrapper);

    if (wrap) {
      let buttons = wrap.querySelectorAll(btns),
        blockCollapseHeights = [],
        collapseBlock = wrap?.querySelectorAll(collapse);

      buttons.forEach((item, i) => {
        blockCollapseHeights.push(collapseBlock[i].clientHeight);
        collapseBlock[i].style.height = 0;

        item.addEventListener("click", (e) => {
          e.stopImmediatePropagation();

          if (collapseBlock[i].style.height == 0 + "px") {
            collapseBlock[i].style.height = blockCollapseHeights[i] + "px";
            item.querySelector(icon).classList.add("rotate");
          } else {
            collapseBlock[i].style.height = 0;
            item.querySelector(icon).classList.remove("rotate");
          }
        });
      });
    }
  }

  /**
   * Отслеживание страницы 404
   */
  function catchNotFound() {
    let flag = document.querySelector(".notFound");

    if (flag) {
      let ref;
      if (localStorage.referrer) {
        ref = localStorage.getItem("referrer");
      }

      let siteurl = document.location.href;
      visitParams = { NotFoundURL: { [siteurl]: { Реферер: ref } } };

      ym(74433037, "reachGoal", "404error", visitParams);
      localStorage.removeItem("referrer");
    } else {
      localStorage.setItem("referrer", document.location.href);
    }
  }

  /**
   * Запуск Видео на секции с розыгрышем
   */
  function findVideos() {
    let videos = document.querySelectorAll(".present__picture");

    for (let i = 0; i < videos.length; i++) {
      setupVideo(videos[i]);
    }
  }

  function setupVideo(video) {
    let link = video.querySelector(".present__picture-video__link"),
      button = video.querySelector(".present__picture-logo");

    video.addEventListener("click", () => {
      let id = video.dataset.id,
        iframe = createIframe(id);

      link.remove();
      button.remove();
      video.classList.remove("active");
      video.appendChild(iframe);
    });

    link.removeAttribute("href");
    video.classList.add("video--enabled");
  }

  function createIframe(id) {
    let iframe = document.createElement("iframe");

    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("allow", "autoplay");
    iframe.setAttribute("src", generateURL(id));
    iframe.classList.add("present__picture-video");

    return iframe;
  }

  function generateURL(id) {
    let query = "?rel=0&showinfo=0&autoplay=1";

    return "https://www.youtube.com/embed/" + id + query;
  }

  /**
   * В каталоге при клике на карточку переход на программу
   */
  $(document).on("click", ".tile.active", function () {
    window.location = $(this).find("a").attr("href");
  });

  /**
   * Добавляем блок с требованиями после блока с категориями подходящих граждан
   */
  function addRequirementsTgu() {
    if (
      window.location.pathname == "/program/realtor72" ||
      window.location.pathname == "/" ||
      window.location.pathname == "/program/marketplace72" ||
      window.location.pathname == "/program/procurementagent" ||
      window.location.pathname == "/program/smmtargetologist" ||
      window.location.pathname == "/program/businessmarketplace" ||
      window.location.pathname == "/program/academicsecretary"
    ) {
      return;
    } else if (
      window.location.pathname == "/program/itprojectmanagement" ||
      window.location.pathname == "/program/psychologist" ||
      getPageName() == "psychologist144"
    ) {
      $(
        /* html */
        `<div class="graduate-wrapper container graduate--tgu tgu--interface">
          <div class="graduate">
            <div class="graduate__picture"></div>
            <span>
              <strong>Требования <br class="graduate__text-br"> к участникам:</strong><br class="graduate__text-br"> граждане РФ с высшим образованием
            </span>
          </div>
        </div>`
      ).insertAfter(".categories");
    } else if (
        window.location.pathname == "/program/operator1c" || 
        window.location.pathname == "/program/social-worker" || 
        window.location.pathname == "/program/warehousemanagement" || 
        window.location.pathname == "/program/cashier" || 
        window.location.pathname == "/program/milling-online" || 
        window.location.pathname == "/program/purchasingagent" || 
        window.location.pathname == "/program/archivist" || 
        window.location.pathname == "/program/passportofficer"
      ) {
      $(
        /* html */
        `<div class="graduate-wrapper container graduate--tgu tgu--interface">
          <div class="graduate">
            <div class="graduate__picture"></div>
            <span>
              <strong>Требования <br class="graduate__text-br"> к участникам:</strong><br class="graduate__text-br"> граждане РФ с основным общим образованием
            </span>
          </div>
        </div>`
      ).insertAfter(".categories");
    } else {
      $(
        /* html */
        `<div class="graduate-wrapper container graduate--tgu tgu--interface">
          <div class="graduate">
            <div class="graduate__picture"></div>
            <span>
              <strong>Требования <br class="graduate__text-br"> к участникам:</strong><br class="graduate__text-br"> граждане РФ со средним профессиональным или высшим образованием
            </span>
          </div>
        </div>`
      ).insertAfter(".categories");
    }
  }  

  /* Инициализация */
  $(function () {
    setNavigation();
    catchNotFound();
    findVideos();
    addRequirementsTgu();

    /* collapse для блоков футера */
    if (window.innerWidth <= 767) {
      collapseList(
        ".footer-item__list--1",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--2",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--3",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--4",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
    }
  });

/*  Кнопка Показать ещё для блока reviewsPartners */
(() => {
  const VISIBLE_REVIEWS = 2;
  const REVIEWS_TO_ADD = 2;

  const addButton = document.querySelector('.reviewsPartners__show-more');
  if (!addButton) {
    return;
  }

  const reviews = document.querySelectorAll('.reviewsPartners__slide');

  const initReviews = () => {
    let currentVisibleReviews = VISIBLE_REVIEWS;
    if (reviews.length <= VISIBLE_REVIEWS) {
      addButton.classList.add('hidden');
    } else {
      reviews.forEach((review, index) => {
        if (index >= VISIBLE_REVIEWS) {
          review.classList.add('hidden');
        }
      });
      addButton.addEventListener('click', () => {
        currentVisibleReviews = currentVisibleReviews + REVIEWS_TO_ADD;
        addReviews(reviews, addButton, currentVisibleReviews);
      });
    }
  };

  const addReviews = (reviews, button, currentVisibleReviews) => {
    reviews.forEach((review, index) => {
      if (
        review.classList.contains('hidden') &&
        index < currentVisibleReviews
      ) {
        review.classList.remove('hidden');
      }
    });
    if (currentVisibleReviews >= reviews.length) {
      button.classList.add('hidden');
    }
  };

  initReviews();
})();
};

export default site;
